import React from 'react';
import { PropTypes } from 'prop-types';
import {
  FormControl, InputBase, MenuItem, Select, withStyles,
} from '@material-ui/core';
import './Dropdown.css';

export function SelectPageDropdown({ currentPage, setCurrentPage, pages }) {
  const BootstrapInput = withStyles((theme) => ({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: theme.palette.background.paper,
      border: 'none',
      color: '#37383b',
      marginTop: '9%',
      fontSize: 16,
      padding: '10px 26px 10px 12px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:focus': {
        borderRadius: 2,
      },
    },
  }))(InputBase);

  const handleChange = (e) => {
    setCurrentPage(Number(e.target.value));
  };

  return (
    <div>

      {/* <FormControl>
        <Select
          id="demo-customized-select-native"
          input={<BootstrapInput />}
          value={option}
          onChange={handleChange}
        >
          {Array.from(Array(pages), (item, index) => (
            <>
              {currentPage === index
                ? <MenuItem value={index} selected className="MenuItem">{index + 1}</MenuItem>
                : <MenuItem value={index} className="MenuItem">{index + 1}</MenuItem>}

            </>
          ))}
        </Select>
      </FormControl> */}
      <FormControl className="paginationDropdown">
        <Select
          id="demo-customized-select-native"
          input={<BootstrapInput />}
          value={currentPage}
          onChange={handleChange}
        >
          {Array.from(Array(pages), (item, index) => (
            <MenuItem value={index}>{index + 1}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

SelectPageDropdown.propTypes = {
  setCurrentPage: PropTypes.element.isRequired,
  pages: PropTypes.element.isRequired,
  currentPage: PropTypes.element.isRequired,
};
